import { camelize, underscore } from 'inflected';
import isObject from 'lodash/isObject';

/**
 * @param {{ [s: string]: any; }} obj
 * @param {{ skip?: string[]; }} [options]
 */
export function camelizeKeys(obj, options = { skip: [] }) {
  return Object.fromEntries(Object.entries(obj)).map(([k, v]) => {
    const { skip } = options;
    if (skip.includes(k)) {
      return [k, v];
    }
    return [camelize(k, false), v];
  });
}

/**
 * @param {{ [s: string]: any; }} obj
 * @param {{ skip?: string[]; }} [options]
 */
export function deepCamelizeKeys(obj, options = { skip: [] }) {
  const { skip } = options;
  if (isObject(obj) && !Array.isArray(obj)) {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => {
        if (skip.includes(k)) {
          return [k, v];
        }
        return [camelize(k, false), deepCamelizeKeys(v, { skip })];
      })
    );
  } else {
    return obj;
  }
}

/**
 * @param {{ [s: string]: any; }} obj
 * @param {{ skip?: string[]; }} [options]
 */
export function underscoreKeys(obj, options = { skip: [] }) {
  return Object.fromEntries(Object.entries(obj)).map(([k, v]) => {
    const { skip } = options;
    if (skip.includes(k)) {
      return [k, v];
    }
    return [underscore(k), v];
  });
}

/**
 * @param {{ [s: string]: any; }} obj
 * @param {{ skip?: string[]; }} [options]
 */
export function deepUnderscoreKeys(obj, options = { skip: [] }) {
  const { skip } = options;
  if (isObject(obj) && !Array.isArray(obj)) {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => {
        if (skip.includes(k)) {
          return [k, v];
        }
        return [underscore(k), deepUnderscoreKeys(v, { skip })];
      })
    );
  } else {
    return obj;
  }
}
